import React, { useState } from 'react';
import { getUILoc, getCardName, groupCards } from '../../../utils/cardUtils.js';
import { CardIllustration } from '../../Card.js';
import CardDetail from '../../CardDetail.js';

const WhimEvent = ({ activeRun, cardDefs, executeWhimExchange, goToNextNodeSelection }) => {
  const [selectedCardId, setSelectedCardId] = useState(null);
  const [eventResultMessage, setEventResultMessage] = useState(null);
  const [inspectCard, setInspectCard] = useState(null);
  
  const totalScale = 5 + activeRun.scaleBonus;
  const isCompleted = activeRun.eventState.completed;

  const handleExchange = () => {
    const oldName = getCardName(selectedCardId);
    const res = executeWhimExchange(selectedCardId);
    if (res.success) {
      setEventResultMessage(getUILoc('YONOTSUNE.EVENTS.WHIM.RESULT').replace('{oldCard}', oldName).replace('{newCard}', getCardName(res.newCardId)));
      setSelectedCardId(null);
    } else {
      alert(res.reason);
    }
  };

  // デッキの集計
  const groupedDeck = groupCards(activeRun.playerDeck);

  return (
    <div className="event-resolver whim-event">
      <h2>{getUILoc('YONOTSUNE.EVENTS.WHIM.NAME')}</h2>
      <p className="resolver-intro" dangerouslySetInnerHTML={{ __html: getUILoc('YONOTSUNE.EVENTS.WHIM.INTRO', { bonus: totalScale }) }} />

      {eventResultMessage && <div className="event-result-banner">{eventResultMessage}</div>}

      {!isCompleted ? (
        <div className="exchange-box">
          <div className="card-selector-area">
            <h3>{getUILoc('LABELS.CURRENT_DECK')}:</h3>
            <div className="modal-scroll-area" style={{ marginTop: '10px' }}>
              <div className="presented-grid">
                {groupedDeck.map((item, index) => {
                  const isActive = selectedCardId === item.id;
                  return (
                    <div 
                      key={index} 
                      className={`pile-card-group clickable ${isActive ? 'active' : ''}`}
                      onClick={() => setSelectedCardId(item.id)}
                      style={{ border: isActive ? '2px solid #4caf50' : '1px solid rgba(255,255,255,0.1)', background: isActive ? 'rgba(76, 175, 80, 0.1)' : 'transparent', padding: '5px' }}
                    >
                      <div className="pile-card-illustration-wrapper">
                        <CardIllustration cardId={item.id} isMini={true} />
                        <div className="pile-card-count-badge">×{item.count}</div>
                        <button className="inspect-btn-mini" style={{ position: 'absolute', bottom: '2px', right: '2px', zIndex: 5 }} onClick={(e) => { e.stopPropagation(); setInspectCard(cardDefs[item.id]); }}>🔍</button>
                      </div>
                      <div className="pile-card-name" style={{ fontSize: '0.7rem' }}>{getCardName(item.id)}</div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          <div className="action-row" style={{ marginTop: '20px' }}>
            <button 
              className="yonotsune-btn green-btn" 
              disabled={selectedCardId === null || totalScale <= 0}
              onClick={handleExchange}
              style={{ flex: 1 }}
            >
              {getUILoc('YONOTSUNE.EVENTS.WHIM.EXECUTE')}
            </button>
            <button className="yonotsune-btn" onClick={() => { goToNextNodeSelection(); setEventResultMessage(null); }} style={{ flex: 1 }}>
              {getUILoc('YONOTSUNE.EVENTS.NEXT_NODE')}
            </button>
          </div>
        </div>
      ) : (
        <div className="action-row">
          <button className="yonotsune-btn" onClick={() => { goToNextNodeSelection(); setEventResultMessage(null); }}>
            {getUILoc('YONOTSUNE.EVENTS.NEXT_NODE')}
          </button>
        </div>
      )}

      {inspectCard && (
        <CardDetail 
          card={inspectCard} 
          cardDefs={cardDefs} 
          onClose={() => setInspectCard(null)} 
        />
      )}
    </div>
  );
};

export default WhimEvent;
